import React, { FC, useMemo } from 'react';

import { FormattedMessage } from 'react-intl';

import { TeamStandingsRecord } from '../../types';

import legendMessages, { LegendItem } from './standingsLegendMessages';
import { groupItems } from './utils';

import {
    DatapointWrapper,
    LabelWrapper,
    LegendBodyWrapper,
    LegendColumn,
    StandingsLegendTitle,
    StandingsLegendWrapper,
} from './styles';

const LEGEND_COLUMNS = 3;

type Props = {
    standings: Array<TeamStandingsRecord>;
};

type ColumnProps = {
    messages: Array<LegendItem>;
};

const ColumnMessages: FC<ColumnProps> = ({ messages }) => (
    <LegendColumn>
        {messages.map((legend: LegendItem, index: number) => (
            <DatapointWrapper key={index}>
                <LabelWrapper $isUppercase>
                    <FormattedMessage {...legend.key} />
                </LabelWrapper>
                <LabelWrapper>
                    &nbsp;-&nbsp;
                    <FormattedMessage {...legend.definition} />
                </LabelWrapper>
            </DatapointWrapper>
        ))}
    </LegendColumn>
);

const StandingsLegend: FC<Props> = () => {
    const groupedLegendItems = useMemo(() => groupItems(legendMessages, LEGEND_COLUMNS), []);

    return (
        <StandingsLegendWrapper>
            <StandingsLegendTitle aria-level={2}>
                <FormattedMessage defaultMessage="Legend" description="Header for Standings Legend" />
            </StandingsLegendTitle>
            <LegendBodyWrapper>
                {Object.values(groupedLegendItems).map((messages, index) => (
                    <ColumnMessages key={index} messages={messages} />
                ))}
            </LegendBodyWrapper>
        </StandingsLegendWrapper>
    );
};

export default StandingsLegend;
